export default "<breadcrumbs></breadcrumbs>\r\n<h1>{{ 'PAGES.TERMS.TITLE' | translate }}</h1>\r\n<p>\r\n  {{ 'PAGES.TERMS.TEXT' | translate }}\r\n</p>";